/**
 * Created by hp on 2017/6/12.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {renderMoney} from '../../utils';

class LecturePaySinglePanel extends Component {
    constructor() {
        super();
        this.onSelectSingle = this.onSelectSingle.bind(this);
    }

    onSelectSingle() {
        this.props.dispatch({
            type: 'LECTURE_SET_SINGLE_LECTURE_PAY'
        });
    }

    render() {
        const {money, isSelectSingleLecture, limitMoney} = this.props;
        return (
            <div className="weui-actionsheet__cell weui-padding wk-border-line-bottom" onClick={this.onSelectSingle}>
                <p className="weui-flex">
                    <i className={"iconfont icon-zhengque " + (isSelectSingleLecture ? "select" : "no-select")}/>
                    <span className="weui-flex__item text-left flex_4">
                        <span className="padding-left">购买单课</span>
                    </span>
                    <span className="weui-flex__item text-right flex_3">
                        <span className="key-num fr">
                            {
                                limitMoney === 0
                                    ? '限时免费'
                                    : `￥${limitMoney ? renderMoney(limitMoney) : renderMoney(money)}`
                            }
                        </span>
                    </span>
                </p>
            </div>
        )
    }
}

export default connect((state) => ({
    money: state.lecture.lecture.money,
    isSelectSingleLecture: state.lecture.isSelectSingleLecture,
    limitMoney: state.lecture.lecture.limit_money ? state.lecture.lecture.limit_money.money : null,
}))(LecturePaySinglePanel);


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePaySinglePanel.js